import Swiper, { Pagination, Navigation } from 'swiper';
Swiper.use([Pagination, Navigation]);

/**
 * STANDALONE CAROUSEL BROWSER CODE
 */

export namespace CarouselBrowser {
	let SetupSlider = () => {
		let carouselBrowsers = document.querySelectorAll('.js-carousel-browser');

		/**
		 * For each carousel setup swiper and provide index classes to things to call out instance specifically.
		 */
		carouselBrowsers.forEach((carouselBrowser, index) => {
			let parent = carouselBrowser.closest('.carousel-browser');
			let leftArrow = parent.querySelector('.swiper-button-prev');
			let rightArrow = parent.querySelector('.swiper-button-next');
			parent.classList.add(`carousel-browser--${index}`);
			carouselBrowser.classList.add(`carousel-browser-${index}`);
			leftArrow.classList.add(`swiper-button-prev--${index}`);
			rightArrow.classList.add(`swiper-button-next--${index}`);

			let fpSliderList = [];

			let fpSlider = new Swiper(`.carousel-browser-${index}`, {
				slidesPerView: 1,
				speed: 400,
				spaceBetween: 10,
				loop: false,

				navigation: {
					nextEl: `.swiper-button-next--${index}`,
					prevEl: `.swiper-button-prev--${index}`
				},

				breakpoints: {
					768: {
						slidesPerView: 2
					},
					992: {
						slidesPerView: 3,
					}
				},
			});

			fpSliderList.push(fpSlider);
			fpSlider.init();
		});
	}
	export const init = () => {
		SetupSlider();
	}
}


/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {  // Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', CarouselBrowser.init);
} else {  // `DOMContentLoaded` has already fired
	CarouselBrowser.init();
}
